













import { Component } from 'vue-property-decorator'
import { Chart } from 'highcharts-vue'
import * as ColorUtils from '@/components/Survey/Utilities/ColorUtility'
import { BaseQuestion } from '@/components/Survey/QuestionTypes/BaseQuestion'
import {
  generateIndexSeries,
  generateSlicedSeries,
  getCategoriesForSlicedQuestion,
  getCategoriesForSlicedVariantQuestion,
  getResponseTotalsForOptions,
  NestedResponses,
  normalizeData,
  SegmentTotalsRecord,
  getChoiceTotalsBySegment,
  generateNumberIndexSeriesData
} from '@/components/Survey/Utilities/ChartUtilities'
import Tabs from '@/components/Tabs/Tabs.vue'
import Tab from '@/components/Tabs/Tab.vue'
import SliceNotSupported from '@/components/Survey/SliceNotSupported.vue'

@Component({
  components: {
    Highcharts: Chart,
    Tabs,
    Tab,
    SliceNotSupported
  }
})
export default class NumberQuestion extends BaseQuestion {
  get indexTotals () {
    const normalizedData = normalizeData(this.indexResponses)
    return getResponseTotalsForOptions(normalizedData)
  }

  get segmentTotals () : SegmentTotalsRecord {
    let responses
    if (this.isSliced && this.isVariant) {
      responses = this.typedSlicedVariantResponses[this.selectedTab]
    } else {
      responses = this.typedSlicedResponses
    }

    const normalizedData: NestedResponses = {}
    for (const [key, segmentResponses] of Object.entries(responses)) {
      normalizedData[key] = normalizeData(segmentResponses)
    }

    return getChoiceTotalsBySegment(normalizedData)
  }

  get indexSeries () {
    const data = generateNumberIndexSeriesData(this.categories, this.indexTotals, this.indexResponses.length, this.colors)
    return generateIndexSeries(data)
  }

  get slicedSeries () {
    return generateSlicedSeries(this.segmentTotals, this.colors, this.indexCategories)
  }

  get series () {
    if (this.isSliced || this.isVariant) {
      return this.slicedSeries
    } else {
      return this.indexSeries
    }
  }

  get chartOptions () {
    return {
      ...this.defaultChartOptions(),
      xAxis: {
        ...this.defaultChartOptions().xAxis,
        categories: this.categories
      },
      series: this.series
    }
  }

  get colors () {
    const colorCount = this.indexCategories.length
    return ColorUtils.generateSequentialColors(colorCount, this.colorConfiguration.sequentialPalette).reverse()
  }

  get indexCategories () {
    return Object.keys(this.indexTotals)
  }

  get categories () : string[] {
    if (this.isSliced && this.isVariant) {
      return getCategoriesForSlicedVariantQuestion(this.typedSlicedVariantResponses, this.selectedTab).slice().reverse()
    } else if (this.isSliced || this.isVariant) {
      return getCategoriesForSlicedQuestion(this.segmentTotals, this.sliceByQuestion)
    } else {
      return this.indexCategories
    }
  }
}
